import React from 'react';
import { cn } from '../../utils/cn';

const VARIANTS = {
  default:  'bg-surface border border-border shadow-xs',
  outline:  'bg-transparent border border-border',
  filled:   'bg-bg-2 border border-transparent',
  ink:      'bg-ink text-cream border border-ink',
  cream:    'bg-cream-2 border border-cream-3',
};

const PADDING = {
  none: 'p-0',
  sm:   'p-3',
  md:   'p-4',
  lg:   'p-6',
};

const RADII = {
  sm: 'rounded-md',
  md: 'rounded-lg',
  lg: 'rounded-xl',
  xl: 'rounded-2xl',
};

export function Card({
  as: Tag = 'div',
  variant = 'default',
  padding = 'md',
  radius = 'md',
  isHoverable = false,
  className,
  children,
  ...rest
}) {
  return (
    <Tag
      className={cn(
        'transition-shadow duration-fast',
        VARIANTS[variant],
        PADDING[padding],
        RADII[radius],
        isHoverable && 'hover:shadow-md cursor-pointer',
        className,
      )}
      {...rest}
    >
      {children}
    </Tag>
  );
}

function Header({ className, children, ...rest }) {
  return <div className={cn('flex items-start justify-between gap-3 mb-3', className)} {...rest}>{children}</div>;
}
function Title({ as: Tag = 'h3', className, children, ...rest }) {
  return <Tag className={cn('text-lg font-bold tracking-tight', className)} {...rest}>{children}</Tag>;
}
function Description({ className, children, ...rest }) {
  return <p className={cn('text-sm text-mute mt-0.5 leading-relaxed', className)} {...rest}>{children}</p>;
}
function Body({ className, children, ...rest }) {
  return <div className={cn(className)} {...rest}>{children}</div>;
}
function Footer({ className, children, ...rest }) {
  return <div className={cn('flex items-center justify-end gap-2 mt-4 pt-3 border-t border-border', className)} {...rest}>{children}</div>;
}

Card.Header = Header;
Card.Title = Title;
Card.Description = Description;
Card.Body = Body;
Card.Footer = Footer;

export default Card;
